module.exports = __webpack_public_path__ + "img/screen-failure.5243b3f6.svg";